import { Component, Input, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { ResponseIO } from 'src/app/models/responseIO';
import { FieldItem } from 'src/app/models/common/field-item';

@Component({
  selector: '',
  template: '',
})
export class AgentPaymentHandlerComponent extends BaseComponent<AgentService> {
  public isDisable;
  public isConfirmBtnEnabled;
  public confirmAccNum;
  public itemData;
  public errorText;
  public changepaymentmode;
  constructor(agentService: AgentService, settingService: SettingService) {
    super(agentService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    // if(this.service.responseIO['data']['PaymentList'][0]['transactionStatusCd']!=null &&
    // this.service.responseIO['data']['PaymentList'][0]['transactionStatusCd']=='Success')
    // this.disableFunc('NO');
    //this.service.responseIO.data.PaymentList[0].agentPaymentDOField10=null;
    if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'ONHOLD' ||
      this.service.responseIO.data.Entity.applicationStatusCd == 'REJECTED'
    ) {
      this.isDisable = true;
    } else this.isDisable = false;
  }

  public onAddPaymentDetail(event) {
    this.service.addPaymentDetail();
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Edit',
      },
    ];
  }

  protected paymentModeCd_change(item: FieldItem) {
    // this.service.setModelFieldValue(item.model, item.model.bankName, null);
    // this.service.setModelFieldValue(item.model, item.model.ifsc, null);
    // this.service.setModelFieldValue(item.model, item.model.branchName, null);
    if (item.model.ifscCd != undefined) {
      item.model.ifscCd = null;
    }
    if (item.model.bankName != undefined) {
      item.model.bankName = null;
    }
    if (item.model.branchName != undefined) {
      item.model.branchName = null;
    }
  }

  // changepaymentmodefunc() : void{
  //     this.service.responseIO.data.Entity.ifsc=null;
  //     //this.service.getBankNameByIFSC(item)==null;
  //     this.service.responseIO.data.bankName=null;
  //     this.service.responseIO.data.branchName=null;
  // }

  protected branchName_focus(item: FieldItem) {
    // if(item.model.branchName!=null)
    // this.service.getBranchNameByBranchCd(item);
    // // console.log(item.model.branchName);
    //    if(item.model.branchName==null && item.model.bankName!=null)
    //   this.service.getBranchName(item);
    // if(item.model.ifscCd!=null)
    // {
    //   this.service.getBranchNameByIFSC(item);
    // }
    //this.service.setItemOptions(item,this.service.branchName[0]);
  }

  protected bankName_focus(item: FieldItem) {
    // item.model.branchName = null;
    // item.model.agentDetailDOField7 = null;
    // this.service.getBankNameByIFSC(item);
    //this.service.getBank(item);
  }

  protected accountNum_change(item: FieldItem) {
    this.itemData = item;
    this.resetConfirmAccNum();
    this.isConfirmBtnEnabled = true;
    this.openModal('ConfirmPopup');
  }
  resetConfirmAccNum(): void {
    this.confirmAccNum = null;
    this.errorText = undefined;
  }

  protected confirmAccNumChange(event) {
    this.itemData =
      this.service != undefined &&
      this.service.responseIO != undefined &&
      this.service.responseIO.data != undefined &&
      this.service.responseIO.data.PaymentList[0] != undefined &&
      this.service.responseIO.data.PaymentList[0].accountNum != undefined
        ? this.service.responseIO.data.PaymentList[0].accountNum
        : this.itemData.fieldValue;
    this.confirmAccNum = event.target.value;
    if (this.confirmAccNum == '' || this.confirmAccNum == null || this.confirmAccNum == undefined) {
      this.errorText = ' Confirm Account Number';
      this.isConfirmBtnEnabled = true;
    } else if (event.target.value != this.itemData) {
      this.errorText = 'Confirm Account Number does not match with Account Number.';
      this.isConfirmBtnEnabled = true;
    } else {
      this.errorText = undefined;
      this.isConfirmBtnEnabled = false;
    }
  }
  protected bankName_change(item: FieldItem) {
    // item.model.branchName = null;
  }

  protected ifscCd_change(item: FieldItem) {
    // item.model.branchName = null;
    // this.service.getBankNameByIFSC(item);
    // this.service.getBranchNameByIFSC(item);
    // console.log('branchName',item.model.branchName);
    //this.service.getBranchNameByBranchCd(item);
    // if(item.model.branchName==null)
    // {
    //   item.model.branchName=this.service.responseIO['data']['values'][0]['desc'];
    // }
  }
  func() {
    //console.log(this.service.responseIO);
    this.service.responseIO.data.PaymentList[0].agentPaymentDOField9 = 'Reset';
    //this.service.responseIO.data.PaymentList[0].agentPaymentDOField10='Reset';
    //this.disableFunc('YES');
    this.agentSubmit();
  }

  // disableFunc(enable:String){

  //   let guid=this.service.responseIO['data']['PaymentList'][0]['guid'];
  //   for (let temp of Object.entries(this.service.responseIO['metadata'][guid])) {
  //     for (let [key, value] of Object.entries(temp)){
  //       if(temp[0]!='transactionStatusCd' && temp[0]!='agentPaymentDOField2')
  //       {temp[1]['ENABLED']=enable;
  //     }
  //     }
  //   }

  //   this.service.refreshMetaData(this.service.responseIO);
  // }

  agentSubmit() {
    this.service.responseIO.data.Entity.stepActionTabs = undefined;
    this.service.submitAgent().subscribe(
      (successResponse) => {
        this.service.responseIO = new ResponseIO();
        this.service.responseIO = JSON.parse(JSON.stringify(successResponse));
        let serviceResponse = this.service.responseIO;
        console.log(successResponse['message']);
      },
      (error) => {
        console.log('Agent submit failed.');
        console.log('Error:', error);
      }
    );
  }

  closeConfirmModal() {
    this.service.responseIO.data.PaymentList[0].accountNum = null;
    this.resetConfirmAccNum();
  }

  closeErrorModal() {
    this.closeModal('ConfirmPopup');
  }
}
